
function wechatAgent (agent, type) {
  // console.log(type, agent.indexOf('micromessenger'))
  if (type === 'WXH5' && agent.indexOf('micromessenger') === -1) {
    return true
  }

  if (agent.indexOf('micromessenger') === -1) {
    return false
  }
  
  if (type === 'WXMP' && agent.indexOf('miniprogram') !== -1) {
    return true
  }

  if (type === 'WXWEB' && agent.indexOf('miniprogram') === -1) {
    return true
  }

  return false
}
const wxMap = ['WXMP', 'WXWEB', 'WXH5']

export function judgeUserAgent (type) {
  var ua = navigator.userAgent.toLowerCase()

  if (wxMap.indexOf(type) !== -1) {
    return wechatAgent(ua, type)
  }
  
  const t = {
    weChat: 'micromessenger', //微信,
    miniProgram: 'miniprogram'
  }

  var isAgent = ua.indexOf(t[type]) != -1
  // if (!isWeixin) {
  //   Toast('请在微信登录')
  // }
  return isAgent
}